import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { outpostStyles, OutpostNavbar, BlurText } from '../components/OutpostShared';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { FaImdb } from 'react-icons/fa';

const { FiX, FiPlay, FiVideo, FiInstagram, FiLinkedin } = FiIcons;

// --- Data Structure ---
// Updated to use objects to support mixed media (MP4, YouTube, Vimeo) and credits
const portfolioCategories = [
  {
    id: 'commercial',
    title: 'Industry Scale',
    description: 'Professional sets with multi-million dollar budgets. Serving essential roles within the Camera and Assistant Director departments.',
    videos: [
      { url: "https://adilo.bigcommand.com/4c3b0177-a485-4239-9252-151ccbb7fd44.mp4" },
      { url: "https://adilo.bigcommand.com/010af44b-c8b5-420c-9c6c-835fa9aa75c2.mp4" },
      { url: "https://www.youtube.com/watch?v=FbtKGhFtSCg" }, // Replaced 3rd video with YouTube link
      { url: "https://adilo.bigcommand.com/18417ec7-33ec-49c6-85e0-eb651d6f70f4.mp4" },
      { url: "https://adilo.bigcommand.com/3623524b-b5e3-4f97-a1a2-fabfc886c6bf.mp4" },
      { url: "https://adilo.bigcommand.com/dbb8c9a9-2d07-4ef7-8a0f-067ca5edefb6.mp4" },
      { url: "https://adilo.bigcommand.com/ac1a0ecc-1637-497a-9e80-c5ca2c60c0cd.mp4" }
    ]
  },
  {
    id: 'experimental',
    title: 'Experimental & AI',
    description: 'Fearless exploration. Utilizing the latest technology and artificial intelligence to push creative boundaries on leaner budgets.',
    videos: [
      { url: "https://adilo.bigcommand.com/78047042-7b75-4f8a-8f13-ceb451f9dd30.mp4" },
      { url: "https://adilo.bigcommand.com/fb45b3f4-8738-4015-8cd6-3f6f45140b07.mp4" },
      { url: "https://adilo.bigcommand.com/858b193a-97d8-4d6a-ba76-48bc2caf36c1.mp4" },
      { url: "https://adilo.bigcommand.com/8f3735dd-e4c2-48b7-8b76-b6c9df936275.mp4" },
      { url: "https://adilo.bigcommand.com/6b7b6dda-fc1f-4fa2-b326-8c8146a42109.mp4" },
      { url: "https://adilo.bigcommand.com/6ab17830-282a-4c66-b8b7-bbd632cb7248.mp4" },
      { url: "https://adilo.bigcommand.com/8cb2fb05-277d-448e-a662-a9329f8eee23.mp4" },
      { url: "https://adilo.bigcommand.com/fe6419e2-4d68-444c-b0c1-985a2de68891.mp4" },
      { url: "https://adilo.bigcommand.com/4f3a6ebd-523e-45c5-a65b-27dc9b0355ce.mp4" },
      { url: "https://adilo.bigcommand.com/f1106034-31d5-46bb-8415-ddfeae673303.mp4" },
      { url: "https://adilo.bigcommand.com/e607f999-efea-49d1-b05b-5e8f298e9092.mp4" },
      { url: "https://adilo.bigcommand.com/projects/jTIgt0_j/edit/VQDk3W5D" },
      { url: "https://adilo.bigcommand.com/projects/jTIgt0_j/edit/BPwpT3Km" },
      { url: "https://adilo.bigcommand.com/baff7227-88b1-4109-b57d-e071f03ed8dd.mp4" },
      { url: "https://adilo.bigcommand.com/fe24e7db-2988-4169-a8c3-a1ce2bd6dd3b.mp4" },
      { url: "https://adilo.bigcommand.com/650be841-a8de-4046-a287-5f92e0d76e72.mp4" },
      { url: "https://adilo.bigcommand.com/dcbe99fc-64c2-4453-9641-df2ec0c98fe6.mp4" },
      { url: "https://adilo.bigcommand.com/1b9bf00b-e890-47d0-8a3f-981011bf19e4.mp4" },
      { url: "https://adilo.bigcommand.com/04080434-a099-425f-83fd-74c35f101391.mp4" },
      { url: "https://adilo.bigcommand.com/4df7286d-83de-4759-a750-55dc799a8853.mp4" },
      { url: "https://adilo.bigcommand.com/e5806649-ff8e-4d35-b53c-f0b2a2570dad.mp4" },
      { url: "https://adilo.bigcommand.com/772892c0-00b5-474b-b802-403e8f640541.mp4" }
    ]
  },
  {
    id: 'passion',
    title: 'Intimate Visions',
    description: 'Solo cinematography passion projects. Keeping our footprint minimal to provide artists and brands access to our lens within their intimate constraints.',
    videos: [
      { url: "https://adilo.bigcommand.com/b07f6205-5ea6-47d2-bd26-3c13b7daf002.mp4" },
      { url: "https://adilo.bigcommand.com/c139cf3d-4a38-4129-b7c7-9877423a3015.mp4" },
      { url: "https://adilo.bigcommand.com/d7ac82c3-8db8-447a-90d7-99041f1921e3.mp4" },
      { url: "https://adilo.bigcommand.com/a81f6fc8-6a5d-47dd-9ff7-f1d3caeb4213.mp4" },
      { url: "https://adilo.bigcommand.com/4ab87507-5d02-4502-8b5d-8a997aef75e3.mp4" },
      { 
        url: "https://vimeo.com/1084051135?turnstile=1.QSnAPdutAXbEIQddSkgLzwGFo43Gtta4BLihQAe-9GwVuvi_GjNe1om9ryLfWMLyKC00rWbcSby1xqYB8uNh_DYRlULbPYKAqyLy4NbIG36e06B2Ey6emQmrImWcdt1vFjuiOhqYxAuzaOHEUqoskmyBOWsKvNSHMKVtqDVfvbBOdE_rTRHD_2YEqPxzRdz0iz6NsSVXoVjHwioXqI8puK6Sx2XswaUEiEvb5tNaiE2Z709vd8paCEUVoxOH5nROrYRFWROoia-k_TnA-2ixDB47oURHCxhQ-SbYf_A4KIlSFTn7Gu5yroFVe8RMxOVPgCMfkcsHpXW5xLrfSIIwnpoP3bCQq6IF3uBZhSUdrUn93EVY4MKm8yzMrB1g1BYr5LyU1KfgABd4fT4M1adlr4lbhT9klwKqYPj6l29Q9vNHyuMszjFwD-qUy8HoWR-k777yLnpK6EjM7KT2eVe4iHnzmd3Eifs-ceECke-358OqpmIwJ3OzSPyXHIQzQHhz_ixPM6esRoFdb-4tpmy28i6D4KQDfznnD7UuGs2lKcwXZgCN8RsjdZGzLnU3L4xA56fO9ZUt6vRUNwDfyuW-7pOUgO24JRz07fvo0zMON7JNnESPv0h8ItvalAyrnnT5.ceaTe2f_WG_zwv1cstuUGw.3a1304ae35fa3c751140c24e5cd3d22fc455592b27e884fdd9bd1c6e92bb798c",
        credits: "Directed by Maxwell Smith | Director of Photography: DuPont Octavius"
      }
    ]
  }
];

// --- Subcomponents ---

// VideoThumbnail handles hover-to-play preview for MP4s and static previews for external links
const VideoThumbnail = ({ video, onClick, index }) => {
  const videoRef = useRef(null);

  const isYouTube = video.url.includes('youtube.com') || video.url.includes('youtu.be');
  const isVimeo = video.url.includes('vimeo.com');
  const isMp4 = !isYouTube && !isVimeo;

  const handleMouseEnter = () => {
    if (isMp4 && videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  };

  const handleMouseLeave = () => {
    if (isMp4 && videoRef.current) {
      videoRef.current.pause();
    }
  };

  // Extract YouTube thumbnail if applicable
  let thumbUrl = '';
  if (isYouTube) {
     const videoId = video.url.includes('v=') ? video.url.split('v=')[1].split('&')[0] : video.url.split('youtu.be/')[1];
     thumbUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  }

  return (
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.1 }}
      className="aspect-video bg-black/5 rounded-xl border border-black/10 relative overflow-hidden group shadow-sm hover:shadow-xl hover:border-black/20 transition-all cursor-pointer"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={() => onClick(video)}
    >
      {isMp4 ? (
        <video
          ref={videoRef}
          src={video.url}
          className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-500"
          muted
          playsInline
          loop
          preload="metadata"
        />
      ) : isYouTube ? (
        <img 
          src={thumbUrl} 
          alt="YouTube Thumbnail" 
          className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-500"
        />
      ) : (
        <div className="w-full h-full bg-black/90 flex flex-col items-center justify-center text-white p-4 text-center">
            <SafeIcon icon={FiVideo} className="w-8 h-8 mb-3 opacity-50" />
            <span className="text-sm opacity-70 font-medium tracking-wide uppercase">Vimeo Link</span>
        </div>
      )}
      
      {/* Credits Overlay */}
      {video.credits && (
        <div className="absolute top-0 left-0 right-0 p-4 bg-gradient-to-b from-black/80 to-transparent z-10">
           <p className="text-white text-[11px] uppercase tracking-wider font-medium text-left opacity-90">{video.credits}</p>
        </div>
      )}
      
      {/* Play Button Overlay */}
      <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center z-20">
        <div className="w-16 h-16 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center pl-1.5 shadow-2xl transform scale-90 group-hover:scale-100 transition-transform duration-300">
          <SafeIcon icon={FiPlay} className="w-6 h-6 text-black" />
        </div>
      </div>
    </motion.div>
  );
};

export default function Portfolio() {
  const [selectedVideo, setSelectedVideo] = useState(null);

  return (
    <div className="outpost-page min-h-screen text-black font-body selection:bg-black/10">
      <style>{outpostStyles}</style>
      <OutpostNavbar />
      
      {/* SECTION 1: Hero */}
      <section className="relative pt-40 pb-24 px-8 md:px-16 lg:px-20 bg-black/[0.01]">
        <div className="max-w-4xl mx-auto text-center relative z-10">
            <motion.div 
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
              className="text-sm font-body text-black/60 mb-6 uppercase tracking-widest"
            >
              // The Archives
            </motion.div>
            
            <BlurText 
              text="Our Portfolio" 
              className="text-6xl md:text-7xl lg:text-[5.5rem] font-heading italic text-black leading-[0.85] tracking-[-3px] mb-8"
            />
            
            <motion.p 
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4, duration: 0.8 }}
              className="text-lg text-black/80 font-body font-light leading-relaxed max-w-2xl mx-auto"
            >
              A curated collection of our finest work, categorized by scale and intent. These are the visions we've captured and the worlds we've built.
            </motion.p>
        </div>
      </section>

      {/* SECTION 2: Categorized Galleries */}
      <section className="relative w-full pb-20 px-8 md:px-16 lg:px-20">
        <div className="max-w-7xl mx-auto space-y-32">
          
          {portfolioCategories.map((category, catIndex) => (
            <div key={category.id} className="relative">
              
              {/* Category Header */}
              <div className="mb-12 md:mb-16 border-t border-black/10 pt-12">
                <motion.h2 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  className="text-4xl md:text-5xl font-heading text-black mb-4"
                >
                  {category.title}
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.2 }}
                  className="text-black/60 max-w-2xl text-lg font-light leading-relaxed"
                >
                  {category.description}
                </motion.p>
              </div>

              {/* Video Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                {category.videos.map((video, index) => (
                  <VideoThumbnail 
                    key={`${category.id}-${index}`} 
                    video={video} 
                    index={index}
                    onClick={setSelectedVideo}
                  />
                ))}
              </div>
            </div>
          ))}

        </div>
      </section>

      {/* SECTION 3: DP Bio */}
      <section className="relative w-full pb-32 px-8 md:px-16 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="border-t border-black/10 pt-20">
            <div className="max-w-4xl">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              >
                <h2 className="text-3xl md:text-4xl font-heading text-black mb-2">Meet Our Cinematographer</h2>
                <h3 className="text-xl md:text-2xl text-black/60 mb-8 font-heading italic">DuPont Octavius</h3>
                
                <div className="space-y-6 text-black/80 font-light leading-relaxed text-lg">
                  <p>
                    DuPont started in the industry in 2013 as an on-air sales coordinator for the Home Shopping Network (HSN). In that role, his focus was working directly with the on-air producer, monitoring live sales trends while the show was broadcasting, and spotting patterns connecting specific shots to sales spikes. If a pattern emerged (e.g., a model wearing a yellow dress driving a sales spike), DuPont would immediately contact the producer to make real-time adjustments.
                  </p>
                  <p>
                    Within six months, DuPont was promoted to Visual Coordinator, determining how products would be presented on air, including prop selection and set dressing. Less than a year later, he advanced to Special Projects Visual Coordinator. In this capacity, he exclusively handled brands HSN considered "special," collaborating with high-profile figures such as Tyra Banks, Nicki Minaj, Keith Urban, Randy Jackson, Shaquille O'Neal, and Joy Mangano.
                  </p>
                  <p>
                    After roughly a year and a half, he was promoted to Stage Manager, taking charge of the entire stage—overseeing both visual coordinators and camera operators. Two years later, HSN moved him to the creative side of the business as a Production Coordinator, where he transitioned from live show brands to producing advertising content specifically for HSN's own products and customers.
                  </p>
                  <p>
                    Following his tenure at HSN, he was recruited by RKC, a local creative agency, serving as Creative Director and managing two of their brands: <em>I Love the Burg</em> and <em>That's So Tampa</em>. After two years, he relocated to Los Angeles, California, working within the Assistant Director and Camera departments on high-end, multi-million dollar productions—a role he continues today.
                  </p>
                  <p>
                    He is also a proud member of the International Cinematographers Guild, a testament to his achievements and skill set within the camera department.
                  </p>
                  
                  <div className="pt-6 mt-6 border-t border-black/10">
                    <p className="font-medium text-black">
                      Why does this matter? DuPont Octavius is our in-house cinematographer, bringing a decade of live-broadcast precision, high-profile project management, and Hollywood-tier camera expertise to every frame the Sans Titre brand captures.
                    </p>
                  </div>
                </div>

                <div className="mt-10 flex flex-wrap gap-4">
                  <a 
                    href="https://www.instagram.com/wearesanstitre.co/" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-black text-white rounded-full hover:bg-black/80 transition-colors text-sm font-medium tracking-wide"
                  >
                    <SafeIcon icon={FiInstagram} className="w-4 h-4" />
                    Our Social Media
                  </a>
                  <a 
                    href="https://www.linkedin.com/in/dupontoctavius/" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-6 py-3 border border-black/20 text-black rounded-full hover:bg-black/5 transition-colors text-sm font-medium tracking-wide"
                  >
                    <SafeIcon icon={FiLinkedin} className="w-4 h-4" />
                    DuPont's LinkedIn
                  </a>
                  <a 
                    href="https://www.imdb.com/name/nm12047895/?ref_=ttfc_fcr_21_16jadore%20dior" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-6 py-3 border border-black/20 text-black rounded-full hover:bg-black/5 transition-colors text-sm font-medium tracking-wide"
                  >
                    <SafeIcon icon={FaImdb} className="w-5 h-5 text-[#f5c518]" />
                    DuPont's IMDb
                  </a>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* FULL SCREEN VIDEO MODAL */}
      <AnimatePresence>
        {selectedVideo && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-xl flex items-center justify-center p-4 md:p-12"
            onClick={() => setSelectedVideo(null)}
          >
            {/* Close Button */}
            <button 
              className="absolute top-6 right-6 md:top-10 md:right-10 text-white/70 hover:text-white transition-colors p-2 z-[101] bg-white/10 rounded-full hover:bg-white/20"
              onClick={() => setSelectedVideo(null)}
            >
              <SafeIcon icon={FiX} className="w-8 h-8 md:w-10 md:h-10" />
            </button>

            {/* Video Player */}
            <motion.div 
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.4, delay: 0.1 }}
              className="relative w-full max-w-7xl aspect-video rounded-2xl overflow-hidden shadow-2xl bg-black"
              onClick={(e) => e.stopPropagation()} // Prevent closing when clicking the video itself
            >
              {(selectedVideo.url.includes('youtube.com') || selectedVideo.url.includes('youtu.be')) ? (
                <iframe 
                  src={`https://www.youtube.com/embed/${selectedVideo.url.includes('v=') ? selectedVideo.url.split('v=')[1].split('&')[0] : selectedVideo.url.split('youtu.be/')[1]}?autoplay=1`}
                  className="w-full h-full"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                />
              ) : selectedVideo.url.includes('vimeo.com') ? (
                <iframe 
                  src={`https://player.vimeo.com/video/${selectedVideo.url.split('vimeo.com/')[1].split('?')[0]}?autoplay=1`}
                  className="w-full h-full"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                />
              ) : (
                <video 
                  src={selectedVideo.url} 
                  controls 
                  autoPlay 
                  className="w-full h-full object-contain"
                />
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
}